module.exports = __webpack_public_path__ + "static/img/aiLogo.26170686.gif";